<template>
  <div
    class="cb-message">
    <span
      ref="icon"
      class="cb-message-icon">
      <avatar :alias="alias"/>
    </span>
    <div
      :ref="messageRef"
      class="cb-message-text" :id="messageRef">
      <span class="time-hour">{{ timeHour }}</span>
      <template>
        <v-rating
          v-model="data.value"
          background-color="orange lighten-3"
          color="orange"
          :length="data.value"
          readonly
          :x-large="!isMobile"
          :dense="isMobile" />
      </template>
    </div>
  </div>
</template>

<script>
  import chatUiMixin from '@/mixins/chat-ui'
  import Avatar from '../Avatar'

  export default {
    components: { Avatar },
    mixins: [ chatUiMixin ],
    data () {
      return {
        messageRef: `message-${this.$uuid.v4()}`
      }
    },
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.smAndDown
      },
      data () {
        return this.record.data
      },
      timeHour () {
        return location.hostname === 'localhost' ? this.record.slug : ''
      }
    },
    mounted () {
      this.iconAnimation()
      this.$nextTick(() => this.messageAnimation(this.messageRef))
    },
    methods: {
      action () {
        this.$emit('action', true)
      }
    }
  }
</script>

<style lang="sass">
  @import '../../assets/style/variables'

  .cb-message
    margin-bottom: 30px
    right: 0
    align-self: flex-end
    flex-direction: row
    display: flex
    align-items: center

    a:hover
      text-decoration: none

    &-icon
      transform: translate(-100px)
      opacity: 0
      align-self: flex-start

      svg
        width: 40px
        height: 40px

    &-text
      color: #000000
      padding: 0px 12px
      position: relative
      font-size: 22px
      font-weight: 300

  @media screen and (max-width: $max-mobile)
    .cb-message
      &-text
        font-size: 18px

      &-icon
        svg
          width: 40px
          height: 40px
</style>
